import { Ban, CheckCircle2, Loader2 } from 'lucide-react';
import React from 'react';

interface BulkActionBarProps {
  count: number;
  loading: boolean;
  onBlock: () => void;
  onEnable: () => void;
  onClear: () => void;
}

export const BulkActionBar: React.FC<BulkActionBarProps> = ({
  count,
  loading,
  onBlock,
  onEnable,
  onClear,
}) => {
  const visible = count > 0;

  return (
    <div
      className={`fixed bottom-6 left-1/2 z-40 -translate-x-1/2 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-32'
      }`}
      aria-hidden={!visible}
    >
      <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-3 shadow-xl">
        <span className="text-sm font-medium text-slate-700">
          {count} unidad{count === 1 ? '' : 'es'} seleccionada{count === 1 ? '' : 's'}
        </span>
        <div className="h-6 w-px bg-slate-200" />
        <button
          type="button"
          onClick={onBlock}
          disabled={loading}
          className="inline-flex items-center gap-1.5 rounded-lg bg-red-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-600 disabled:opacity-60"
        >
          {loading ? <Loader2 size={15} className="animate-spin" /> : <Ban size={15} />}
          Bloquear
        </button>
        <button
          type="button"
          onClick={onEnable}
          disabled={loading}
          className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-emerald-600 disabled:opacity-60"
        >
          {loading ? <Loader2 size={15} className="animate-spin" /> : <CheckCircle2 size={15} />}
          Habilitar
        </button>
        <button
          type="button"
          onClick={onClear}
          className="rounded-lg px-3 py-1.5 text-sm font-medium text-slate-500 hover:bg-slate-100 hover:text-slate-700"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};
